export interface TalentPresentationRow {
  id: number;
  accountStatus?: number | null;
}

/**
 * Row selection follows UI state; deactivation styling follows User lifecycle.
 * Legacy Hygienist.status is intentionally outside this presentation contract.
 */
export function getTalentPresentationRowClass(
  item: TalentPresentationRow,
  selectedTalentId?: number | null
): string {
  const classes: string[] = [];
  if (selectedTalentId === item.id) classes.push("selected-hygienist-row");
  if (Number(item.accountStatus) === -4) classes.push("deactivated-row");
  return classes.join(" ");
}
